<template>
<div id="mirrorItemType" class="mirrorItemType" v-if="itemList !== null" :class="{ 'is-modal': isMirrorMenuModal }">
  <MirrorHeader title="SELECT TYPE" />
  <h2 class="mirrorItemType__brand">
    <img :src="itemList[0].brandMainImage" :alt="itemList[0].brandName" />
  </h2>
  <div class="mirrorItemType__title">
    <h3 class="mirrorItemType__title__main">SELECT TYPE</h3>
    <p v-if="itemList[0].brandName === 'LONGCHAMP'" class="mirrorItemType__title__sub">コレクションを見る</p>
    <p v-else class="mirrorItemType__title__sub">カスタムしたい商品を選択してください</p>
  </div>
  <div class="mirrorItemType__typelist">
    <div class="mirrorItemType__typelist__wrap">
      <router-link
        v-for="item in itemList" :key="item.id" v-if="item.isDev !== true"
        :to="{ name: 'mirror-item-detail', params: { brandID: brandID, id: item.id } }"
        class="mirrorItemType__typelist__wrap__type">
        <div class="mirrorItemType__typelist__wrap__type__img">
          <img :src="item.mainImage[0]" alt="item" />
        </div>
        <p class="mirrorItemType__typelist__wrap__type__title">{{ item.name }}</p>
      </router-link>
    </div>
  </div>
  <MirrorFooter />
  <router-link to="/mirror" class="mirrorBackBtn">
    <img src="@/assets/images/mirror/commons/commons-backBtn.svg" alt="Back">
  </router-link>
  <div @click="isMirrorMenuModal = true" class="mirrorGlobalMenu">
    <img src="@/assets/images/mirror/commons/commons-menu.svg" alt="Menu">
  </div>
  <MirrorMenuModal
    v-if="isMirrorMenuModal"
    @closeMenu="isMirrorMenuModal = false" />
  <ScreenSaverModal
    v-if="isScreenSaver"
    @closeScreenSaver="isScreenSaver = false" />
</div>
</template>

<script>
import MirrorHeader from '@/components/mirror/MirrorHeader'
import MirrorFooter from '@/components/mirror/MirrorFooter'
import MirrorMenuModal from '@/components/mirror/MirrorMenuModal'
import ScreenSaverModal from '@/components/mirror/ScreenSaverModal'
import ScreenSaver from '@/assets/class/ScreenSaver'
import customMgr from '@/modules/CustomManager'

export default {
  mixins: [ScreenSaver],
  components: {
    MirrorHeader,
    MirrorFooter,
    MirrorMenuModal,
    ScreenSaverModal
  },
  beforeRouteEnter (to, from, next) {
    customMgr.getAllItems(
      Number(to.params.brandID),
      'mirror'
    ).then((itemList) => {
      if (itemList.length > 0) {
        next(vm => vm.setItemList(itemList))
      } else {
        next('/mirror')
      }
    })
  },
  props: {
    brandID: Number
  },
  data () {
    return {
      itemList: null,
      isMirrorMenuModal: false
    }
  },
  metaInfo: {
    meta: [
      { name: 'viewport', content: 'width=1080,user-scalable=no' }
    ]
  },
  methods: {
    setItemList (itemList) {
      this.itemList = itemList
    }
  }
}
</script>

<style lang="scss" scoped>
.mirrorItemType {
  min-height: 100%;
  background-color: $right-gray;
  &.is-modal {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  &__brand {
    @include headerBrandLogo;
  }
  &__title {
    background-color: $base-white;
    text-align: center;
    padding: 70px 0 40px;
    &__main {
      font-size: 50px;
      font-weight: bold;
    }
    &__sub {
      font-size: 25px;
      margin-top: 15px;
    }
  }
  &__typelist {
    &__wrap {
      padding: 50px 100px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      &__type {
        width: calc((100% - 60px) / 3);
        background-color: $base-white;
        margin: 0 0 30px 0;
        padding: 30px;
        &:nth-of-type(3n + 2) {
          margin: 0 30px 30px;
        }
        &__img {
          width: 100%;
          height: 230px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        &__title {
          text-align: center;
          font-size: 22px;
          font-weight: bold;
          line-height: 1.5;
          margin: 10px 0 0 0;
        }
      }
    }
  }
  .mirrorBackBtn {
    @include mirrorBackBtn;
  }
  .mirrorGlobalMenu {
    @include mirrorMenuBtn;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/mirror/MirrorItemType.vue